import React from 'react'
import { Badge, Modal, ModalContent } from '@mc/design-system'
import { isMobile } from '@mc/devices'
import { usePrimaryCta } from '@mc/growth'
import { useTranslation } from '@mc/i18n'
import { PromoTermsLink, usePromotion } from '@mc/promo-utils'
import { Locations } from '@mc/track-event'
import { SignUpButton } from '../..'
import {
  ExplainerModalFreeGiftLegend,
  ExplainerModalFreeGiftTermsLink,
} from '../../../experiments/prcng-955_v1_plan_z_free_gift'
import { PROMO_I18N_NAMESPACE } from '../../../lib/constants'
import { setIsExplainerModalDismissed } from '../../../lib/helpers'
import { UrgencyText } from '../../featureVariables'
import { CloseButton } from './CloseButton'
import { PromoText } from './PromoText'
import classes from './ExplainerModalContent.module.scss'

interface ExplainerModalContentProps {
  closeModal: () => void
  pageSource: string
}

export const ExplainerModalContent = ({
  closeModal,
  pageSource,
}: ExplainerModalContentProps) => {
  const { t } = useTranslation(PROMO_I18N_NAMESPACE)
  const { ctaHref } = usePrimaryCta()
  const { variables } = usePromotion()

  return (
    <Modal
      size='medium'
      canClickOutsideToClose={!isMobile()}
      show
      onClose={closeModal}
      className={classes.explainerModal}
    >
      <ModalContent className='mc-invert mc-text-color--dark mc-corners--md mc-overflow--hidden'>
        <div className='mc-theme-light mc-bg-light d-flex flex-column mc-text--center justify-content-center'>
          <div className='mc-p-8'>
            <CloseButton closeModal={closeModal} />

            <Badge
              kind='dim'
              className={`${classes.badge} mc-text-color--dark mc-text--bold mc-text--uppercase`}
            >
              <UrgencyText />
            </Badge>

            <PromoText />

            <ExplainerModalFreeGiftLegend />

            <div className='mc-my-8'>
              <p>{t('common.description')}</p>

              <ExplainerModalFreeGiftTermsLink>
                <PromoTermsLink i18nKey='offerTerms.promoExplainerModal' />
              </ExplainerModalFreeGiftTermsLink>
            </div>
            <SignUpButton
              fullWidth
              href={ctaHref}
              location={Locations.PROMOTION_MODAL}
              pageSource={pageSource}
              onClick={() =>
                setIsExplainerModalDismissed(variables?.promo_key as string)
              }
            />
          </div>
        </div>
      </ModalContent>
    </Modal>
  )
}
